import moment from 'moment'

export const POSTPONED_COMMUNICATION_CANONICAL_ID = 62

export function normalizeFollowTime(time) {
  if (!time) {
    return '00:00:00'
  }
  return time.length === 5 ? `${time}:00` : time
}

export function getPostponedMaxDays(appSettings = {}) {
  const days = parseInt(appSettings.postponed_communication_max_days, 10)
  return Number.isFinite(days) && days > 0 ? days : 7
}

export function getPostponedMaxFollowUpDate(appSettings = {}) {
  return moment().add(getPostponedMaxDays(appSettings), 'days').format('YYYY-MM-DD')
}

export function isPostponedCommunicationClass(canonicalClassId) {
  return Number(canonicalClassId) === POSTPONED_COMMUNICATION_CANONICAL_ID
}

/**
 * Client-side validation mirroring PostponedCommunicationService (wsata_api).
 * @returns {string|null} error message
 */
export function validatePostponedFollowUp(payload, appSettings = {}) {
  if (!payload?.follow_date) {
    return 'تاريخ المتابعة مطلوب في تصنيف أجل التواصل'
  }
  if (!payload?.follow_time) {
    return 'وقت المتابعة مطلوب في تصنيف أجل التواصل'
  }

  const now = moment()
  const followMoment = moment(
    `${payload.follow_date} ${normalizeFollowTime(payload.follow_time)}`,
    'YYYY-MM-DD HH:mm:ss'
  )

  if (!followMoment.isValid() || !followMoment.isAfter(now)) {
    return 'تاريخ المتابعة ينبغي أن يكون أكبر من التاريخ والوقت الحالي'
  }

  const maxDays = getPostponedMaxDays(appSettings)
  const maxAllowed = moment().add(maxDays, 'days').endOf('day')

  if (followMoment.isAfter(maxAllowed)) {
    const suffix = maxDays === 7 ? 'أيام (أسبوع)' : 'يوم'
    return `تاريخ المتابعة يجب ألا يزيد عن ${maxDays} ${suffix}`
  }

  return null
}
